export default "__VITE_ASSET__zozo8q$s__"